import config from 'config'

export const buildFavoritesUrl = (favoritesPath: string | undefined, locale: i18n.Locale, params: string): string => {
  if (!favoritesPath) return ''
  const vistaprintRoot = config.client.vistaprintRoot[locale]
  const favoritesUrl = `${vistaprintRoot}${favoritesPath}?tab=templates&${params}`

  return favoritesUrl
}
